export enum OversizePropertytoCalculate {
  Density = 'Density',
  Volume = 'Volume',
}
